import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingDataObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Function} param.toQueryString
   * @param {Function} param.fromCamelToSnakeCase
   */
  constructor({config, toQueryString, fromCamelToSnakeCase}) {
    super({config, toQueryString, fromCamelToSnakeCase})
    this._config = config
    this._toQueryString = toQueryString
    this._fromCamelToSnakeCase = fromCamelToSnakeCase
  }

  _mapData = dataObject =>
    Object.keys(dataObject)
      .sort()
      .reduce((accObject, key) => {
        const newKey = this._fromCamelToSnakeCase(key)
        const parsedValue = this._parseValue({key, value: dataObject[key]})

        return {
          ...accObject,
          [newKey]: parsedValue
        }
      }, {})

  /**
   * @method
   * @private
   */
  _parseValue = ({key, value}) => {
    if (value === null) return value
    if (Array.isArray(value)) return value.join(':').toLowerCase()

    if (typeof value === 'object') {
      return Object.values(value).join(':').toLowerCase()
    }

    if (typeof value === 'string') return value.toLowerCase()
    if (typeof value === 'number') return this._parseNumberValue({key, value})

    return value
  }

  /**
   * Some numeric parameters should be string for Segment requirements
   */
  _parseNumberValue = ({key, value}) => {
    const {SEARCH_FILTERS_AS_STRING_TYPES} = this._config.get('tracking')
    const numberValue = Number(value)
    const shouldBeString = SEARCH_FILTERS_AS_STRING_TYPES.some(stringProperty => key === stringProperty)

    return shouldBeString ? numberValue.toString() : numberValue
  }

  /**
   * @param {Object} params
   */
  map = dataObject => this._mapData(dataObject)
}
